<template>
  <Layout title="Buchen" h1="Buchen" :banner="$page.props.banner" metaDescription="Einfach in den Skiurlaub! Gruppenreisen für Skifans sind unsere Spezialität und das seit über 30 Jahren. Bucht jetzt eure Skireise in tolle Skigebiete." metaKeywords="SCOL, SCOL Skireisen, Reise buchen, Skireise buchen, Skifahren, Ski, Skiurlaub, Skiurlaub buchen, Skiurlaub Österreich, Skiurlaub Italien">
    <div id="booking">
      <section id="booking-intro">
        <p class="text-center mt-5" v-if="booking && booking.travel_date_id">
          Schön, dass du dich für
          <span class="fs-4">{{
            booking.travel_date.travel.get("destination")
          }}</span>
          entschieden hast.
        </p>
        <p
          class="text-center fs-3 fw-bold"
          v-if="booking && booking.travel_date_id"
        >
          {{ booking.travel_date.timespan }}
        </p>
      </section>
      <section class="scol-section">
        <form @submit.prevent="onSubmit">
          <div class="container py-5">
            <div class="card border-0 rounded-0">
              <!-- Body -->
              <div class="card-body">
                <ul class="nav nav-pills nav-fill mt-2 mb-5">
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="{ active: step == 1 }"
                      aria-current="page"
                      href="#"
                      @click.prevent="goto(1)"
                      >Reisedaten</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="{ active: step == 2 }"
                      href="#"
                      @click.prevent="goto(2)"
                      >Teilnehmer</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="{ active: step == 3 }"
                      href="#"
                      @click.prevent="goto(3)"
                      >Zahlung</a
                    >
                  </li>
                  <li class="nav-item">
                    <a
                      class="nav-link"
                      :class="{ active: step == 4 }"
                      href="#"
                      @click.prevent="goto(4)"
                      >Bestätigung</a
                    >
                  </li>
                </ul>

                <template v-if="step == 1">
                  <!-- Step 1 -->
                  <div v-if="booking && booking.travel_date_id">
                    <strong>{{
                      booking.travel_date.travel.get("destination")
                    }}</strong>
                    <p>{{ booking.travel_date.travel.get("description") }}</p>
                  </div>
                </template>
                <template v-else-if="step == 2">
                  <!-- Step 2 -->

                  <div class="row">
                    <div class="col-6">
                      <!-- Formular -->
                      <div class="participant" v-if="participant_form.show">
                        <h3 class="text-primary">
                          Teilnehmer
                          <template v-if="participant_form_create"
                            >hinzufügen</template
                          >
                          <template v-else
                            >{{
                              parseInt(participant_form.index)
                            }}
                            bearbeiten</template
                          >
                        </h3>

                        <div class="row g-2 mb-2">
                          <div class="col">
                            <select
                              v-model="participant_form.gender"
                              class="form-select rounded-0 border-0"
                            >
                              <option :value="null">Anrede*</option>
                              <option value="H">Herr</option>
                              <option value="F">Frau</option>
                              <option value="D">Divers</option>
                            </select>
                          </div>
                          <div class="col">
                            <input
                              type="date"
                              class="form-control rounded-0 border-0"
                              v-model="participant_form.birthday"
                              placeholder="Geburtstag*"
                            />
                          </div>
                        </div>
                        <div class="row g-2 mb-2">
                          <div class="col">
                            <input
                              type="text"
                              class="form-control rounded-0 border-0"
                              v-model="participant_form.firstname"
                              placeholder="Vorname*"
                              maxlength="100"
                            />
                          </div>
                          <div class="col">
                            <input
                              type="text"
                              class="form-control rounded-0 border-0"
                              v-model="participant_form.lastname"
                              placeholder="Nachname*"
                              maxlength="100"
                            />
                          </div>
                        </div>

                        <button
                          type="button"
                          class="btn btn-outline-primary rounded-pill mt-2"
                        >
                          <i class="fa-solid fa-plus"></i> Teilnehmer erfassen
                        </button>
                      </div>
                      <button
                        v-else-if="participants_count < participants_max"
                        type="button"
                        class="btn btn-outline-primary rounded-pill mt-2"
                      >
                        <i class="fa-solid fa-plus"></i> Neuer Teilnehmer
                      </button>
                    </div>
                    <div class="col-6">
                      <!-- List participants -->
                      <h3 class="text-primary">
                        Teilnehmerliste ({{ participants_count }})
                      </h3>
                      <div
                        class="bg-primary text-white p-2 d-flex justify-content-between"
                      >
                        <div>
                          {{ travelDateClass.get("days") }}
                          {{
                            travelDateClass.get("days") > 1 ? "Tage" : "Tag"
                          }}, {{ search.adults_count }}
                          {{
                            search.adults_count > 1
                              ? "Erwachsene"
                              : "Erwachsener"
                          }}
                        </div>
                        <div class="text-end"><strong>895</strong></div>
                      </div>
                      <div
                        class="booking-participant-show"
                        v-for="(participant, index) in form.booking
                          .participants"
                        :key="'booking-participant-show-' + index"
                      >
                        <div class="d-flex justify-content-between p-2">
                          <div>
                            <strong
                              >Teilnehmer {{ parseInt(index) + 1 }}</strong
                            >
                          </div>
                          <div>
                            <i
                              class="fa-solid fa-person"
                              v-if="participant.adult"
                            ></i>
                            <i class="fa-solid fa-child-reaching" v-else></i>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </div>

              <!-- Footer -->
              <div class="card-footer bg-white border-0">
                <div class="row pb-2">
                  <div class="col">
                    <button
                      type="button"
                      class="btn btn-outline-primary rounded-pill"
                      v-if="has_back"
                      style="min-width: 10rem"
                      @click="back()"
                    >
                      <i class="fa-solid fa-chevron-left"></i>zurück
                    </button>
                  </div>
                  <div class="col text-end">
                    <button
                      type="submit"
                      class="btn btn-outline-primary rounded-pill"
                      v-if="has_next"
                      style="min-width: 10rem"
                    >
                      <i class="fa-solid fa-chevron-right"></i> weiter
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div id="booking-login">
              <p class="text-center">
                <strong
                  >Du bist nicht angemeldet.
                  <a href="#" class="text-decoration-none"
                    >Jetzt anmelden</a
                  ></strong
                ><br />
                <small
                  >Du hast keinen Account?
                  <a href="#" class="text-decoration-none"
                    >Jetzt registrieren</a
                  ></small
                >
              </p>
            </div> -->
          </div>
        </form>
      </section>
    </div>
  </Layout>
</template>
<script>
import { Inertia } from "@inertiajs/inertia";
import { Link, useForm } from "@inertiajs/inertia-vue3";
import Layout from "./Layouts/Booking";
import Booking from "../Models/Booking";
import TravelDate from "../Models/TravelDate";
import BookingParticipant from "../Models/BookingParticipant";
import Search from "../Models/Search";

export default {
  components: {
    Layout,
    Link,
  },
  data: () => ({
    step: 1,
    step_max: 4,
    participants_max: 10,
    form: useForm({
      travel_date_id: null,
      participants: null,
    }),
    participant_form: {
      show: false,
      index: null,
      gender: null,
      firstname: null,
      lastname: null,
      birthday: null,
    },
    search: null,
    booking: null,
  }),
  methods: {
    next() {
      if (this.has_next) {
        this.goto(this.step + 1);
      }
    },
    back() {
      if (this.has_back) {
        this.goto(this.step - 1);
      }
    },
    goto(step) {
      this.step = step;
      Inertia.visit(
        this.$route("booking", [
          this.booking.travel_date_id,
          this.booking.stepFind(this.step),
        ]),
        { preserveScroll: true }
      );
    },
    updateParticipant(index) {
      this.form.booking.participants[index] = BookingParticipant.make(
        this.participant_form
      );
    },
    onSubmit() {
      console.log(this.form);
    },
  },
  mounted() {
    // Init search
    this.search = new Search().fromStorage();

    // const storage = new BrowserSessionStorage

    // Init booking
    this.booking = Booking.make(this.$page.props.booking);

    // Init current step
    this.step = this.booking.stepFindIndex(this.$page.props.step);

    if (!this.participants_count) {
      this.participant_form.show = true;
      this.form.booking.participants = this.search.participants;
    }
  },
  computed: {
    has_next() {
      return this.step < this.step_max;
    },
    has_back() {
      return this.step > 1;
    },
    participants_count() {
      if (!this.form.booking) {
        return 0;
      }
      return this.form.booking.participants.length;
    },
    booking() {
      if (!this.form) {
        return;
      }
      return this.form.booking;
    },
    travelDateClass() {
      return new TravelDate(this.$page.props.travelDate);
    },
    participant_form_create() {
      return this.participant_form.index === null;
    },
  },
};
</script>
